import React, { useEffect, useState } from 'react';
import BoardWrapper from '../Board/BoardWrapper';
import { fetchGeneralMilestones } from 'utils/fetchData';
import { createProjectMasterBoardSocket, selectLoader } from 'utils/Helpers';
import { useAuth } from 'contexts/AuthContext';
import APIServices from 'services/APIServices';

const MasterCalender = () => {
  const { user } = useAuth();
  const [masterMilestones, setMasterMilestones] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [masterCalenderSocket, setMasterCalenderSocket] = useState([]);
  const [projectBoardIds, setProjectBoardIds] = useState([]);
  const [teams, setTeams] = useState([]);

  const fetchTeams = async () => {
    try {
      const response = await APIServices.get(`/team/${user?.companyId?._id}`);
      if (response.members) {
        setTeams(response.members || []);
      } else if (response?.data?.message) {
        setTeams([]);
      }
    } catch (error) {
      console.error('Error fetching the teams:', error);
    } finally {
    }
  };

  const fetchMilestones = async () => {
    try {
      const milestonesData = await fetchGeneralMilestones();
      console.log(milestonesData);
      setMasterMilestones(milestonesData.milestones || []);
      const projectBoardIds = [...new Set(milestonesData.milestones.map((m) => m.projectBoardId?._id).filter(Boolean))];
      setProjectBoardIds(projectBoardIds);
      let masterCalenderSocket = createProjectMasterBoardSocket(user._id, milestonesData.milestones);
      setMasterCalenderSocket(masterCalenderSocket);
    } catch (err) {
      console.error('Error fetching general milestones:', err);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    fetchTeams();
    fetchMilestones();
  }, []);

  return (
    <>
      {pageLoading ? (
        <div className="nodata-loader">{selectLoader(70)}</div>
      ) : (
        <div className="px-3 master_calender_wrapper">
          <BoardWrapper
            companyTeam={teams}
            projectBoardId=""
            isMasterCalender={true}
            masterMilestones={masterMilestones}
            masterCalenderSocket={masterCalenderSocket}
            projectBoardIds={projectBoardIds}
          />
        </div>
      )}
    </>
  );
};

export default MasterCalender;
